import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import { Link, Redirect, useParams } from "react-router-dom"
import Header from '../../Header';
import '../../ShippingData.css'
import '../../Dashboard.css'
import '.././Entire_Details.css'
import './Part_Layout.css'
import { Host } from '../../App';
import throttle from 'lodash/throttle';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Entire_Details from '../Entire_Details';
import Edit_Part_layout from './Edit_Part_layout';


function Part_Layout_Woodshop() {
  var [del, setdel] = useState(1);
  const [postList, setPostList] = useState([]);
  var [Part_Name, setPart_Name] = useState({});
  var [Category, setCategory] = useState({});
  const [PartNo, setPartNo] = useState({});
  const [Date1, setDate1] = useState(new Date());
  const [Postartdate, setPoStartdate] = useState();
  const [Poenddate, setPoEnddate] = useState(Date1.toISOString().slice(0, 10));
  const [customer, setCustomer] = useState({});
  const [Customers, setCustomers] = useState([]);
  const [partNo, setpartNo] = useState([]);
  const [part_dataset, setpart_dataset] = useState([]);
  const [Part_details, setPart_details] = useState([]);
  var token = (window.localStorage.getItem("acessToken"));
  var totalQtyShipped = 0;
  const [showDiv, setShowDiv] = useState(false);
  const [Edit, setEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    var timer = setInterval(() => setDate1(new Date()), 10)
    return function cleanup() {
      clearInterval(timer)
    }
  });
  const ToggleEdit = () => {
    setEdit(!Edit);

  };
  const queryParams = {
    Part_Name: JSON.stringify(Part_Name),
    PartNo: JSON.stringify(PartNo),
    customer: JSON.stringify(customer),
    Category: JSON.stringify(Category),
    token: token
  };

  const toggleDiv = () => {
    setShowDiv(!showDiv);
  }


  useEffect(() => {
    Axios.get(`https://` + Host + `/woodshop/partLayout/search`, { params: queryParams }).then((data) => {
      setPostList(data.data)
    })
  }, [Part_Name, PartNo, customer, part_dataset, del])

  const Entire_data_req = (PO_NO, PART_NO) => {
    setShowDiv(true);
    Axios.get(`https://` + Host + `/woodshop/Entire_details/${JSON.stringify(PO_NO)},${JSON.stringify(PART_NO)},${token}`).then((data) => {
      setPart_details(data.data)
    })
      .catch(function (error) {
        console.log(error.response);
      });

  };

  // to retreive customers
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/Customers/${token}`).then((data) => {
      setCustomers(data.data)
    });
  }, [])
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/partNo/${token}`).then((data) => {
      setpartNo(data.data)
    });
  }, [])
  // to retreive part dataset
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/part_dataset/${token}`).then((data) => {
      setpart_dataset(data.data)
    });
  }, [])
  // method to retrieve data combinely
  const search = () => {
    Axios.get(`https://` + Host + `/api/shippedData/search/${JSON.stringify(Part_Name)},${JSON.stringify(PartNo)},${Postartdate},${Poenddate},${JSON.stringify(customer)},${token}`).then((data) => {
      setPostList(data.data)
      console.log("Search called");
    })
  }
  const Deleted = (PO_NO, PART_NO, ACTUAL_SHIP_DATE) => {
    setdel(del = del + 1)
    console.log("delete called" + del);

    // Axios.delete('https://`+ Host + `/api/Shippeddata/Delete', { PO_NO: PO_NO, PART_NO: PART_NO })
    Axios.delete(`https://` + Host + `/api/actualShippeddata/Delete/${PO_NO},${PART_NO},${ACTUAL_SHIP_DATE},${token}`).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message, {
          autoClose: 1000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px', color: 'red' },
        });
        search();
      }
    })
      .catch(function (error) {
        console.log(error.response);
      });

  };
  const [changedRows, setChangedRows] = useState(new Set());
  const handleUpdate = (e, index, key) => {
    const { value } = e.target;
    updateData(index, key, value);

  };
  const updateData = (index, key, value) => {
    setPostList(prevData => {
      const newData = [...prevData];
      newData[index][key] = value;
      return newData;
    });
    // Add the index of the changed row to the set of changed rows
    setChangedRows(prevRows => new Set(prevRows).add(index));
  };

  const Update = () => {
    ////console.log(COMMeNTS);
    setIsLoading(true);
    const changedData = [...changedRows].map(index => {
      return postList[index];
    });

    console.log(changedData);
    Axios.post(`https://` + Host + `/woodshop/part_layout/Update`, { changedData: JSON.stringify(changedData), token: token }).then((response) => {
      if (response.status === 200) {
        window.alert(response.data.message);
        setdel(del + 1);
        setIsLoading(false);
      }
    })
      .catch(function (error) {
        console.log(error.response);
      });
  };
  return (
    <div className="MainPage_data">
      <div>
        <br></br>
        <Link to="/">
          <input type="button" class="btn btn-success" defaultValue="Logout" id="logout" />
        </Link>
      </div>
      <div className={Edit ? 'slide-down' : 'slide-up'}>
        <Edit_Part_layout part_layout={postList} />
        <br></br>
      </div>
      <div class="Container">
        <div class="row">
          <div class="col">
            {/* Grab the particular Operator name */}
            <input type='text' class="form-control form-rounded" placeholder='PART NO' onChange={(e) => {
              setPart_Name(e.target.value)
            }} />
          </div>
          <div class="col">
            {/* Grab the particular Operator name */}
            <input type='text' class="form-control form-rounded" placeholder='PART NO' list="PartNo" onChange={(e) => {
              setPartNo(e.target.value)
            }} />
            <datalist id="PartNo">
              <option></option>
              {postList.map(x => {
                return <option>{x.Part_No}</option>
              })}
            </datalist>

          </div>
          <div class="col">
            <div class="row" >
              <div class="col" id='moldng'>
                {/* Grab the particular dates */}
                <input type='text' class="form-control form-rounded" placeholder='CATEGORY' list="Category" onChange={(e) => {
                  setCategory(e.target.value)
                }} />
                <datalist id="Category">
                  <option></option>
                  {postList.map(x => {
                    return <option>{x.Category}</option>
                  })}
                </datalist>
                {/*<button class="btn btn-success" onClick={dates}>Submit</button > */}
                <span class="tooltiptext">Filter By ACTUAL SHIP DATE </span>

              </div>
              <div class="col" >
                <button class="btn btn-success" onClick={ToggleEdit}>Edit/Add New Part</button>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <input type='text' class="form-control form-rounded" placeholder='Customer' list='Customers' onChange={(e) => {
                setCustomer(e.target.value)
              }} />
              <datalist id="Customers">
                <option></option>
                {Customers.map(x => {
                  return <option>{x.Customer}</option>
                })}
              </datalist>
            </div>
            <div class="row">

            </div>
          </div>
        </div>
        <br></br>
        <br></br>
        <div id="RRM_table">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>PART NO</th>
                <th>PART NAME</th>
                <th>CUSTOMER</th>
                <th>SIZE</th>
                <th>QTY PER SHEET</th>
                <th>TIMING(MIN)</th>
                <th>CATEGORY</th>
                <th>REQUIRED PCS</th>
                <th>SHEET NO</th>
                {Edit ? <th>UPDATE</th> : null}

              </tr>
            </thead>
            {postList.map((val, index) => (
              <tbody key={val.Sr_No}>
                <tr>
                  <td>
                    {Edit ? (
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => handleUpdate(e, index, 'Part_No')}
                        defaultValue={val.Part_No}
                      />
                    ) : (
                      val.Part_No
                    )}
                  </td>
                  <td>
                    {Edit ? (
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => handleUpdate(e, index, 'Part_Name')}
                        defaultValue={val.Part_Name}
                      />
                    ) : (
                      val.Part_Name
                    )}
                  </td>
                  <td>
                    {Edit ? (
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => handleUpdate(e, index, 'Customer')}
                        defaultValue={val.Customer}
                      />
                    ) : (
                      val.Customer
                    )}
                  </td>
                  <td>
                    {Edit ? (
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => handleUpdate(e, index, 'Size')}
                        defaultValue={val.Size}
                      />
                    ) : (
                      val.Size
                    )}
                  </td>
                  <td>
                    {Edit ? (
                      <input
                        type="number"
                        className="form-control form-rounded"
                        onBlur={(e) => handleUpdate(e, index, 'Qty_Per_Sheet')}
                        defaultValue={val.Qty_Per_Sheet}
                      />
                    ) : (
                      val.Qty_Per_Sheet
                    )}
                  </td>
                  <td>
                    {Edit ? (
                      <input
                        type="number"
                        className="form-control form-rounded"
                        onBlur={(e) => handleUpdate(e, index, 'Timing_min')}
                        defaultValue={val.Timing_min}
                      />
                    ) : (
                      val.Timing_min
                    )}
                  </td>
                  <td>
                    {Edit ? (
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => handleUpdate(e, index, 'Category')}
                        defaultValue={val.Category}
                      />
                    ) : (
                      val.Category
                    )}
                  </td>
                  <td>
                    {Edit ? (
                      <input
                        type="number"
                        className="form-control form-rounded"
                        onBlur={(e) => handleUpdate(e, index, 'Required_Pcs')}
                        defaultValue={val.Required_Pcs}
                      />
                    ) : (
                      val.Required_Pcs
                    )}
                  </td>
                  <td>
                    {Edit ? (
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onBlur={(e) => handleUpdate(e, index, 'Sheet_Item_No')}
                        defaultValue={val.Sheet_Item_No}
                      />
                    ) : (
                      val.Sheet_Item_No
                    )}
                  </td>

                  {Edit ? (
                    <td>
                      <input
                        type="button"
                        className="btn btn-primary"
                        onClick={Update}
                        defaultValue="Update"
                      /></td>
                  ) : null}

                </tr>
              </tbody>
            ))}

          </table>
        </div>
      </div>

      {isLoading ?
        <div className='overlay'>
          <div class="text-center">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div> : null}
    </div >
  )
}

export default Part_Layout_Woodshop;